export class Hints {
    specificHintsCountForDiscipline = 0;
    GENERAL_HINTS_COUNT = 9;
    setSpecificHintsCountForDiscipline(count) {
        this.specificHintsCountForDiscipline = count;
    }
    getHintText(disciplineID) {
        const random = Math.random();
        if (this.specificHintsCountForDiscipline > 0 && random < 0.5) {
            const index = Math.round(Math.random() * (this.specificHintsCountForDiscipline - 1));
            return `hint-${disciplineID}-${index}`;
        }
        return `hint-0-${Math.round(Math.random() * (this.GENERAL_HINTS_COUNT - 1))}`;
    }
}
export const hints = new Hints();
//# sourceMappingURL=Hints.js.map